// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1Pxl2","footer":"ModalFilter_footer__2JGj9"};